export function getStorageValue(key) {
  return localStorage.getItem(key);
}

export function setStorageValue(key, value) {
  localStorage.setItem(key, value);
}

export function currentLanguage(dir) {
  return getStorageValue("language");
}
